const defaultMenuClass = 'main-menu';

function hideNavigationGroup(themes) {
  const group = $('#mainNavigation .group');
  group.each(function () {
    const groupItem = $(this);
    const theme = themes.find((theme) => groupItem.children().first().text().includes(theme.name));
    groupItem.addClass(defaultMenuClass);
    if (theme) {
      groupItem.addClass(theme.class + '-menu');

      if (themes.some((theme) => theme.hideManinNav)) {
        groupItem.hide();
        if (!$('body').hasClass(theme.class)) {
          groupItem.remove();
        }
      }

      if (themes.some((theme) => theme.hideSubItems)) {
        groupItem.find('.items').addClass('hidden-item');
        groupItem.addClass('disable-nav');
      }
    }
  });
}

function createSecondLevel($group) {
  const $secondLevelList = $group.children();
  if ($secondLevelList.length > 2) {
    $secondLevelList.each(function () {
      const $item = $(this);
      if ($item.hasClass('subitems')) {
        $item.removeClass('subitems');
        $item.addClass('items');
      }
    });
  }
}

function createFirstLevel($menu) {
  $menu.removeClass('items').addClass('groups');
  const $firstLevelList = $menu.children();
  $firstLevelList.first().remove();

  $firstLevelList.each(function () {
    const $group = $(this);
    $group.removeClass('item').addClass('group');
    if ($group.children().length > 2) {
      createSecondLevel($group);
    }
  });
}
// Create the menu structure
function createMenu($menu, themes) {
  $('#mainNavigation').addClass(themes[0].class + '-menu');
  const $groups = $($menu).find('.items');

  const $mainNavigationUL = $('#mainNavigation ul.groups');
  $mainNavigationUL.last().after($groups);
  $mainNavigationUL.first().remove();
  createFirstLevel($groups);
}

function applyThemeNavigation(themes) {
  const activeTheme = themes.find((theme) => $('body').hasClass(theme.class));

  if (activeTheme) {
    const $activeMenu = $(`.${activeTheme.class}-menu`);
    $(`.${defaultMenuClass}`).remove();
    createMenu($activeMenu, themes);
  }
}

export default function createCustomNav(themeValue) {
  const themes = [
    {
      name: themeValue.navItemName,
      class: themeValue.baseThemeClass,
      homeLink: themeValue.navItemUrl,
      hideManinNav: themeValue.hideThisOnMainMenu,
      hideSubItems: themeValue.hideTheseSubItems,
    },
  ];
  $(globalThis).on('load', function () {
    hideNavigationGroup(themes);
    applyThemeNavigation(themes);
    $('.header #mainNavigation').css('opacity', 1);
  });
}
